import { TICKET_DETAILS } from '../actions/event';

export const ticketDetailsReducer = (state = '', action) => {
  switch (action.type) {
    case TICKET_DETAILS:
      return action.payload;
  }
  return state;
};
